import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'mosResultColorPipe'
})
export class MosResultColorPipe implements PipeTransform {
  transform(value: number): any {

    if (value > 3.5) return 'green';
    if (value >= 2.5) return 'orange';
    if (value > 0) return 'red';
    return 'grey';
  }
}
